var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.594,
    height: 14.492,
    viewBox: "0 0 11.594 14.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M4,5.623A3.623,3.623,0,1,1,7.623,9.246,3.623,3.623,0,0,1,4,5.623Z",
    transform: "translate(-0.826 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11249",
    "data-name": "Path 11249",
    d: "M2.061,15.061A3.623,3.623,0,0,1,4.623,14H8.971a3.623,3.623,0,0,1,3.623,3.623v1.449a.725.725,0,0,1-.725.725H1.725A.725.725,0,0,1,1,19.072V17.623A3.623,3.623,0,0,1,2.061,15.061Z",
    transform: "translate(0 -3.305)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.813abc7c1b057f129c78e58e808f4288.svg";
export { ForwardRef as ReactComponent };